import { BehaviorSubject } from 'rxjs'
import Cookies from 'js-cookie'
import { clearAllCache, getJsonData } from '../../global/data/service-cache.js'
import { getLongTermCookieOptions } from '../environments/config.js'
import mockProfileData from '../../../test/components/Navigation/mock-data/mock-profile-response.json'
import { isLocal } from '../environments/index.js'

const LOGGED_OFF = 'LOGGEDOFF'
const LOGGED_IN = 'LOGGEDIN'
const PROFILE_URL = '/adv.svc/secure/profile'
const ESC_SIGNED_IN_KEY = 'ESC_SIGNED_IN'
const ESC_PROFILE_KEY = 'ESC_PROFILE'
const CONTACT_KEY = 'CONTACT_KEY'
const CM_USER_STATUS_COOKIE = 'CM_USER_STATUS'
const CM_USER_TYPE_COOKIE = 'CM_USER_TYPE'
export const ENCRYPTED_USER_ID_COOKIE_NAME = 'CTN_UID'
export const USER_LEVEL_TRACKING_ID_COOKIE_NAME = 'CTN_USER_LEVEL_ACTIVITY_ID'

const LOGIN_DEBUG_LOCAL = false

let AuthenticationManagerInstance

AuthenticationManagerInstance =
  window.CTIAuthenticationManager ||
  (function () {
    const AuthenticationManager = {
      userContext: [],
    }

    const subject = new BehaviorSubject(null)

    AuthenticationManager.init = () => {
      if (!isInvestor()) {
        if (isLocal() && LOGIN_DEBUG_LOCAL && isLoggedIn()) {
          subject.next(mockProfileData.value)
          setEmailSubscriptionCenterProfileCookie(mockProfileData.value)
        } else if (isLoggedIn()) {
          getJsonData(PROFILE_URL)
            .then((data) => {
              subject.next(data.value)
              setEmailSubscriptionCenterProfileCookie(data.value)
            })
            .catch((error) => {
              console.log('Auth_Manager_Error', error)
            })
        }
      }
    }

    AuthenticationManager.getProfileServiceBehaviorSubject = () => {
      return subject
    }

    AuthenticationManager.getUserContext = () => {
      return AuthenticationManager.userContext
    }

    AuthenticationManager.addUserContext = (ctx) => {
      AuthenticationManager.userContext.push(ctx)
    }

    AuthenticationManager.init()

    AuthenticationManagerInstance =
      window.CTIAuthenticationManager || AuthenticationManager
    window.CTIAuthenticationManager = AuthenticationManagerInstance
    return AuthenticationManagerInstance
  })()

function getAuthManagerInstance() {
  return AuthenticationManagerInstance
}

function getUserContext() {
  return AuthenticationManagerInstance.getUserContext()
}

function addUserContext(ctx) {
  AuthenticationManagerInstance.addUserContext(ctx)
}

function isContextAllowed(userContextArray, linkContextArray) {
  let matchFound = true

  linkContextArray.forEach(function (linkContext) {
    matchFound = false

    userContextArray.forEach(function (userContext) {
      if (userContext === linkContext) {
        matchFound = true
      }
    })

    if (!matchFound) {
      return matchFound
    }
  })

  return matchFound
}

function isInvestor() {
  const investorSite =
    window.location.pathname.split('/')[1] === 'investor' ||
    window.location.pathname.split('/')[1] === 'investorspa' ||
    window.location.href.indexOf('/cti-investor') >= 0

  return investorSite
}

function isInstitutional() {
  const isInstitutional =
    window.location.pathname.split('/')[1] === 'institutional' ||
    window.location.href.indexOf('/cti-institutional') >= 0

  return isInstitutional
}

function isInvestorAdvisorOrInstitutional() {
  return isInstitutional()
    ? 'institutional'
    : isInvestor()
      ? 'investor'
      : 'advisor'
}

function isLoggedIn() {
  return (
    Cookies.get(CM_USER_TYPE_COOKIE) === 'ADV' &&
    Cookies.get(CM_USER_STATUS_COOKIE) !== LOGGED_OFF
  )
}

function logOff() {
  Cookies.remove(CM_USER_STATUS_COOKIE)
  localStorage.removeItem(ESC_SIGNED_IN_KEY)
  localStorage.removeItem(ESC_PROFILE_KEY)
  Cookies.set(CM_USER_STATUS_COOKIE, LOGGED_OFF, { secure: true })
  localStorage.setItem(ESC_SIGNED_IN_KEY, LOGGED_OFF)
}

function isLoggedIntoSubscriptionCenter() {
  return localStorage.getItem(ESC_SIGNED_IN_KEY) === LOGGED_IN
}

function setLoggedInSubscriptionCenter() {
  localStorage.setItem(ESC_SIGNED_IN_KEY, LOGGED_IN)
}

function logOffSubscriptionCenter() {
  localStorage.removeItem(ESC_SIGNED_IN_KEY)
}

export function setLogin(username, externalId, ssoSessionToken) {
  // this sets a cookie, not local storage
  if (ssoSessionToken) {
    setSSOSessionToken(ssoSessionToken)
  }

  setLoginWithoutSettingCSMSessionCookie(username, externalId, ssoSessionToken)
}

const setSSOSessionToken = function (ssotoken) {
  // HACK
  // LOLZ WE ARE GOING LIVE WITH THIS, SO WHEN COLUMBIA STOPS LOADING BECAUSE
  // OF BUNK COOKIES, WE CAN NARROW IT DOWN TO THIS LINE OF CODE THAT BROKE IT ALL, THANKS SSO

  // FOR NOW LETS NOT DO THIS, THE SERVICE SHOULD BE DOING IT
  // $.cookie.raw = true
  // $.cookie('CSMSESSION', ssotoken, App.COOKIE_OPTIONS_DEFAULT)
  // $.cookie.raw = false
  Cookies.set('CSMSESSION', ssotoken, { secure: true })
}

export function setLoginWithoutSettingCSMSessionCookie(username, externalId) {
  Cookies.set(CM_USER_TYPE_COOKIE, 'ADV', { secure: true })

  Cookies.set(CM_USER_STATUS_COOKIE, LOGGED_IN, { secure: true })
  setUsername(username)
  setExternalId(externalId)

  if (isInternal()) {
    Cookies.set('CM_INT_USER', 'true', { secure: true })
  }

  clearAllCache()
}

export function setProfileCookie() {
  Cookies.set('PRFL_ACTY', 'yes', {
    secure: true,
  })
}

export const setUsername = function (username) {
  window.localStorage.setItem('username', username)
}

const setExternalId = function (externalId) {
  window.localStorage.setItem('externalId', externalId)
}

export const getUsername = function () {
  return window.localStorage.getItem('username')
}

export const isInternal = function () {
  return checkIfEmailIsInternal(getUsername())
}

/**
 * ZOMG HACK
 * Checking to see if internal if they have ampf or columbia email accounts
 * or if its an internal SSO ID (no @ email format)
 * @param email
 * @returns {boolean}
 */
export function checkIfEmailIsInternal(email) {
  return (
    checkIfSSO(email) ||
    email?.indexOf('@ampf.com') >= 0 ||
    email?.indexOf('@qa.ampf.com') >= 0 ||
    email?.indexOf('@columbiamanagement.com') >= 0 ||
    email?.indexOf('@qa.columbiamanagement.com') >= 0 ||
    email?.indexOf('@columbiathreadneedle.com') >= 0 ||
    email?.indexOf('@qa.columbiathreadneedle.com') >= 0 ||
    email?.indexOf('@columbiathreadneedleus.com') >= 0 ||
    email?.indexOf('@qa.columbiathreadneedleus.com') >= 0
  )
}

export function checkIfSSO(email) {
  return email?.indexOf('@') < 0
}

export function setEncryptedUserId(userId) {
  function sha256(str) {
    function hex(buffer) {
      const hexCodes = []
      const view = new DataView(buffer)
      for (let i = 0; i < view.byteLength; i += 4) {
        const value = view.getUint32(i)
        const stringValue = value.toString(16)
        const padding = '00000000'
        const paddedValue = (padding + stringValue).slice(-padding.length)
        hexCodes.push(paddedValue)
      }
      return hexCodes.join('')
    }
    const buffer = textEncode(str)
    const res = crypto.subtle.digest('SHA-256', buffer)
    if (res.then) {
      return res.then(function (hash) {
        return hex(hash)
      })
    } else if (res.result) {
      // IE11
      return {
        then: function (resolver) {
          resolver(hex(res.result))
        },
      }
    }
  }

  function textEncode(str) {
    if (window.TextEncoder) {
      return new TextEncoder('utf-8').encode(str)
    }
    const utf8 = unescape(encodeURIComponent(str))
    const result = new Uint8Array(utf8.length)
    for (let i = 0; i < utf8.length; i++) {
      result[i] = utf8.charCodeAt(i)
    }
    return result
  }

  try {
    sha256(userId).then(function (data) {
      localStorage.setItem(ENCRYPTED_USER_ID_COOKIE_NAME, data)

      Cookies.set(ENCRYPTED_USER_ID_COOKIE_NAME, data, {
        ...getLongTermCookieOptions(),
        secure: true,
      })
    })
  } catch (error) {
    console.log(error)
  }
}

function getRandomId() {
  const length = 32
  const charSet = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let randomString = ''

  for (let i = 0; i < length; i++) {
    const randomPosition = Math.floor(Math.random() * charSet.length)
    randomString += charSet.substring(randomPosition, randomPosition + 1)
  }

  return randomString
}

export function setTrackingIdCookie() {
  const randomId = getRandomId()

  localStorage.setItem(USER_LEVEL_TRACKING_ID_COOKIE_NAME, randomId)
  Cookies.set(USER_LEVEL_TRACKING_ID_COOKIE_NAME, randomId, {
    secure: true,
    ...getLongTermCookieOptions(),
  })
}

export function keepSSOSessionAlive() {
  getJsonData('/api/secure/noop')
}

export function setEmailSubscriptionCenterProfileCookie(profileData) {
  if (!localStorage.getItem(ESC_PROFILE_KEY) && profileData) {
    const storageProfile = {
      firstName: profileData.firstNm,
      lastName: profileData.lastNm,
      emailId: profileData.emailId,
      token: null,
      wholeSalerID: null,
      role: 'Advisor',
      firmName: profileData.firmNm,
      firmId: profileData.firmId,
      parentFirmName: profileData.parentFirmNm,
      parentFirmId: profileData.parentFirmId,
    }
    localStorage.setItem(ESC_SIGNED_IN_KEY, LOGGED_IN)
    localStorage.setItem(ESC_PROFILE_KEY, JSON.stringify(storageProfile))
  }
}

export {
  isInvestor,
  isInstitutional,
  isInvestorAdvisorOrInstitutional,
  isLoggedIn,
  logOff,
  isContextAllowed,
  getAuthManagerInstance,
  getUserContext,
  addUserContext,
  isLoggedIntoSubscriptionCenter,
  setLoggedInSubscriptionCenter,
  logOffSubscriptionCenter,
  ESC_PROFILE_KEY,
  CONTACT_KEY,
}
